import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "leaflet/dist/leaflet.css";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); window.__wnInstall = e; });

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
    navigator.serviceWorker.ready.then((reg) => {
      const urls = [window.location.origin + "/", ...performance.getEntriesByType("resource").map((r) => r.name)]
        .filter((u) => u.startsWith("http") && !u.includes("/api/") && !u.includes("hot-update") && !u.includes("posthog"));
      reg.active?.postMessage({ type: "CACHE_URLS", urls: [...new Set(urls)] });
    });
  });
}
